// extracted by mini-css-extract-plugin
export default {"wrapper":"info_wrapper__5O6qd","main":"info_main__fk-8y","tabs":"info_tabs__nV5bJ","tab":"info_tab__CqyYy","active":"info_active__xhVWN","noActive":"info_noActive__T-CPf"};